import React, { useEffect } from 'react'
import { Redirect, Route, Router, Switch, useHistory } from 'react-router-dom'
import 'src/scss/style.scss'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import 'aos/dist/aos.css'
import 'src/assets/css/ck-editor-content-styles.css'
import 'react-phone-number-input/style.css'
import { useSelector } from 'react-redux'
// import { clearMessage } from 'src/actions/message'
import ToastAlert from 'src/components/ToastAlert'
import _ from 'lodash'
import AOS from 'aos'

// import { SET_MESSAGE } from './actions/types'
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse" />
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./pages/login/Login'))
const Seat = React.lazy(() => import('./pages/event/Seat'))
const EventFormResult = React.lazy(() => import('./pages/event/FormResult'))
const ThankYou = React.lazy(() => import('./pages/event/ThankYou'))
const MonitorEvent = React.lazy(() => import('./pages/monitor-event'))
const MonitorExport = React.lazy(() => import('./pages/monitor-event/MonitorExport'))
// const EventLists = React.lazy(() => import('./pages/event/Lists'))
// const EventForm = React.lazy(() => import('./pages/event/Form'))
// const Register = React.lazy(() => import('./views/pages/register/Register'))
// const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
// const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

// class App extends Component {
//   render() {
//     return (
//       <React.Suspense fallback={loading}>
//         <Switch>
//           <Route exact path="/login" name="Login Page" render={(props) => <Login {...props} />} />
//           {/*<Route*/}
//           {/*  exact*/}
//           {/*  path="/register"*/}
//           {/*  name="Register Page"*/}
//           {/*  render={(props) => <Register {...props} />}*/}
//           {/*/>*/}
//           {/*<Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />*/}
//           {/*<Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />*/}
//           <Route path="/" name="Home" render={(props) => <DefaultLayout {...props} />} />
//         </Switch>
//       </React.Suspense>
//     )
//   }
// }

const App = () => {
  const { user: currentUser } = useSelector((state) => state.auth)
  const history = useHistory()

  useEffect(() => {
    AOS.init({ duration: 1000 })
  }, [])

  return (
    <>
      <ToastAlert />
      <React.Suspense fallback={loading}>
        <Router history={history}>
          <Switch>
            <Route
              path="/event/seat/:id"
              exact
              name="Seat"
              render={(props) => <Seat {...props} />}
            />
            <Route
              path="/register/preview/:id"
              exact
              name="Event Form"
              render={(props) => <EventFormResult {...props} />}
            />
            <Route
              path="/register/:slug"
              exact
              name="Event Form"
              render={(props) => <EventFormResult {...props} />}
            />
            <Route
              path="/thank-you"
              exact
              name="Thank You"
              render={(props) => <ThankYou {...props} />}
            />
            {!_.isEmpty(currentUser) && (
              <Route
                path="/monitor-event"
                exact
                name="Monitor Event"
                render={(props) => <MonitorEvent {...props} />}
              />
            )}
            {!_.isEmpty(currentUser) && (
              <Route
                path="/monitor-realtime"
                exact
                name="Monitor Realtime"
                render={(props) => <Seat {...props} />}
              />
            )}
            {!_.isEmpty(currentUser) && (
              <Route
                path="/monitor-export"
                exact
                name="Monitor Export"
                render={(props) => <MonitorExport {...props} />}
              />
            )}
            {!_.isEmpty(currentUser) ? (
              currentUser.level === 'monitor' ? (
                <Redirect to="/monitor-event" />
              ) : (
                <Route path="/" name="Home" render={(props) => <DefaultLayout {...props} />} />
              )
            ) : (
              <Route
                exact
                path="/login"
                name="Login Page"
                render={(props) => <Login {...props} />}
              />
            )}
            <Redirect to="/login" />
          </Switch>
        </Router>
      </React.Suspense>
    </>
  )
}

export default App
